import React from 'react';
import styled from 'styled-components';

import Section from '@/components/templates/doctor/detail/components/Section/Section';
import theme from '@/styles/theme';
import { Notice } from '@/types/doctor';

interface Props {
  notice: Notice;
}

const DoctorNotice = ({ notice }: Props) => {
  return (
    <>
      <Section>
        <NoticeWrap>
          <NoticeTitleRow>
            <NoticeBadge>공지</NoticeBadge>
            <NoticeTitle>{notice.title}</NoticeTitle>
          </NoticeTitleRow>
          <NoticeContent>{notice.content}</NoticeContent>
        </NoticeWrap>
      </Section>
    </>
  );
};

export default DoctorNotice;

const NoticeWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  width: 100%;
`;

const NoticeTitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-self: stretch;
  gap: 8px;
  margin-bottom: 8px;
`;

const NoticeBadge = styled.div`
  display: flex;
  height: 22px;
  padding: 0 4px;
  border-radius: 4px;
  align-items: center;
  background-color: ${theme.color.red600};
  ${({ theme }) => `
    ${theme.typography.UI13SB};
    color: ${theme.color.white};
  `};
`;

const NoticeTitle = styled.div`
  display: flex;
  ${({ theme }) => `
    ${theme.typography.UI15SB};
    color: ${theme.color.gray700};
  `};
`;

const NoticeContent = styled.div`
  display: flex;
  align-self: stretch;
  text-overflow: ellipsis;
  ${({ theme }) => `
    ${theme.typography.UI14R};
    color: ${theme.color.gray700};
  `};
  line-height: 24px !important;
`;
